import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LayOut from "../components/LayOut";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/blog.css"; // Custom CSS for styling

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          `https://portfoliomern-mxue.onrender.com/api/v1/blog/blogs`
        );
        setBlogs(response.data.blogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogs([]);
      }
    };
    fetchBlogs();
  }, []);

  const handleReadMore = (id) => {
    navigate(`/blog/${id}`);
  };

  return (
    <LayOut title={"Blog Post"}>
      <div className="container py-5 blog-container">
        <h1 className="text-center mb-4 blog-title">Coding Articles</h1>
        {Array.isArray(blogs) && blogs.length > 0 ? (
          <div className="row g-4">
            {blogs.map((blog) => (
              <div className="col-md-4" key={blog._id}>
                <div className="card blog-card h-100">
                  <div className="card-body">
                    <h5 className="card-title">{blog.title}</h5>
                    <p className="blog-date">
                      Created at: {new Date(blog.createdAt).toDateString()}
                    </p>
                    <p className="blog-text">
                      {blog.content.substring(0, 100)}...
                    </p>
                    <button
                      className="btn blog-btn"
                      onClick={() => handleReadMore(blog._id)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-muted">No blogs found.</p>
        )}
      </div>
    </LayOut>
  );
};

export default BlogList;
